import React, { useEffect, useCallback, useState } from 'react';
import '../Styles/DeletionDialog.scss';

const DeletionDialog = ({
  isOpen,
  title = "SUPPRESSION",
  itemName,
  itemTitle,
  itemDetail,
  onConfirm,
  onCancel
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && !isDeleting) {
      onCancel();
    }
  };

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape' && !isDeleting) {
      onCancel();
    }
  }, [onCancel, isDeleting]);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
    } finally {
      setIsDeleting(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div className="deletion-dialog-overlay" onClick={handleBackdropClick}>
      <div className="deletion-dialog-container">
        <div className="deletion-dialog-header">
          <div className="deletion-dialog-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="deletion-dialog-titles">
            <h2 className="deletion-dialog-title">{title}</h2>
          </div>
          <button
            className="deletion-dialog-close"
            onClick={onCancel}
            disabled={isDeleting}
            aria-label="Fermer"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M15 5L5 15M5 5L15 15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        <div className="deletion-dialog-content">
          <div className="deletion-dialog-warning">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>Vous êtes sur le point de supprimer ce {itemName === 'FACTEUR DE RISQUE' ? 'facteur de risque' : 'code du travail'}</span>
          </div>

          {itemName && (
            <div className="deletion-dialog-item">
              <h5 className="item-name">{itemName}</h5>
            </div>
          )}

          {itemTitle && (
            <div className="deletion-dialog-item">
              <h5 className="item-title">{itemTitle}</h5>
            </div>
          )}

          {itemDetail && (
            <div className="deletion-dialog-detail">
              <pre className="item-detail">{itemDetail}</pre>
            </div>
          )}
        </div>

        <div className="deletion-dialog-actions">
          <button
            className="deletion-dialog-button deletion-dialog-button--secondary"
            onClick={onCancel}
            disabled={isDeleting}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="button-icon">
              <path
                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                fill="currentColor"
              />
              <path
                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                fill="currentColor"
              />
            </svg>
            Non
          </button>
          <button
            className="deletion-dialog-button deletion-dialog-button--danger"
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <div className="spinner"></div>
                Suppression...
              </>
            ) : (
              <>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="button-icon">
                  <path
                    d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5zM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 1.152l.557 10.056A2 2 0 0 0 5.046 16h5.908a2 2 0 0 0 1.993-1.792l.557-10.056a.58.58 0 0 0-.01-1.152H11zM9 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 9 5zm-3 0a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 6 5z"
                    fill="currentColor"
                  />
                </svg>
                Oui, supprimer
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletionDialog;